module.exports = __webpack_public_path__ + "static/media/johnny-2.jpeg";